<template>
  <v-card>
    <v-data-table
      :items="clientManifest"
      :headers="headers"
    >
      <template v-slot:item="props">
        <tr>
          <td style="text-align: center" v-for="(header, index) in headers" :key="index">{{props.item[header.value]}}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  // @vuese
  // Card that displays uploaded csv manifest from client in a table.
  // @group Applications
  export default {
    name: "CsvPreview",
    props: {
      // Client manifest (Array) we get from the /files endpoint of the clientapplications
      clientManifest: Array,
    },
    data() {
      return {
        headers: [],
      }
    },
    mounted() {
      for (var header of Object.keys(this.clientManifest[0])) {
        this.headers.push({text: header, value: header, align: 'center', sortable: false});
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/CreateClient/CsvPreview.vue